// import { failResponse } from "./actions";
import { RecordStatusType } from "./declarations";

export interface gameHistoryItem {
  game_provider_id: string;
  game_provider: string;
  game_code: string;
  game_name_eng: string;
  game_name_ch: string;
  bet_amount: string;
  win_amount: string;
  loss_amount: string;
  jackpot_amount: string;
  profit_loss: string;
  before_balance: string;
  after_balance: string;
  game_timestamp: string;
}

// export const safeHandling = async <T>(func: () => Promise<T | failResponse>, errorFunc: (value: string) => void) => {
//   try {
//     const res = await func();
//     if (res && typeof res === "object" && "status_code" in res && res.status_code !== 0) {
//       errorFunc("Unexpected response");
//       return;
//     }
//     return res as T;
//   } catch (e: any) {
//     errorFunc(e.message);
//     console.log(e);
//   }
// };

export const formatLinkToTitle = (s: string) => {
  // captilize first letter of each word, and replace - to space
  return s
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export function formatNumber(numberString: string | number, decimal: number = 2): string {
  try {
    if (typeof numberString === "string") {
      numberString = parseFloat(numberString.replace(/,/g, ""));
      if (isNaN(numberString)) {
        throw new Error("Invalid number string");
      }
    }
    return numberString.toLocaleString(undefined, {
      minimumFractionDigits: decimal,
      maximumFractionDigits: decimal,
    });
  } catch (error) {
    console.error("Error formatting number:", error);
    return "0.00";
  }
}

export const formatTitleToLink = (s: string) => s.toLowerCase().split(" ").join("-");

export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = { day: "2-digit", month: "short", year: "numeric" };
  return date.toLocaleDateString("en-GB", options);
}

export const processHistoryData = (data: any) => {
  if (!data || !data.length) return [];

  const result = [];

  // Add type="transaction" to all items
  interface Transaction {
    created_at: string;
    [key: string]: any; // Add other properties as needed
  }

  interface TransactionWithType extends Transaction {
    type: string;
  }

  const transactionsWithType: TransactionWithType[] = data.map((item: Transaction) => ({
    ...item,
    type: "transaction",
  }));

  // Add first transaction
  result.push({
    type: "date",
    date: transactionsWithType[0].created_at,
  });
  result.push(transactionsWithType[0]);

  // Loop through remaining transactions
  for (let i = 1; i < transactionsWithType.length; i++) {
    // Check if dates are different
    if (transactionsWithType[i].created_at !== transactionsWithType[i - 1].created_at) {
      result.push({
        type: "date",
        date: transactionsWithType[i].created_at,
      });
    }

    result.push(transactionsWithType[i]);
  }

  return result;
};

export const processGameHistoryData = (data: gameHistoryItem[]) => {
  if (!data || !data.length) return [];

  const result = [];
  interface TransactionWithType extends gameHistoryItem {
    type: string;
  }
  // add type="item" to all item in data
  const transactionsWithType: TransactionWithType[] = data.map((item) => ({ ...item, type: "item" }));

  // Add first transaction
  result.push({
    type: "date",
    date: transactionsWithType[0].game_timestamp,
  });
  result.push(transactionsWithType[0]);

  // Loop through remaining transactions
  for (let i = 1; i < transactionsWithType.length; i++) {
    // Check if dates are different
    if (transactionsWithType[i].game_timestamp !== transactionsWithType[i - 1].game_timestamp) {
      result.push({
        type: "date",
        date: transactionsWithType[i].game_timestamp,
      });
    }

    result.push(transactionsWithType[i]);
  }

  return result;
};

export const getStatusColor = (status: RecordStatusType) => {
  switch (status) {
    case RecordStatusType.PENDING:
      return "#FFA500";
    case RecordStatusType.APPROVED:
      return "#258966";
    case RecordStatusType.REJECTED:
      return "#b6162c";
    case RecordStatusType.IN_PROGRESS:
      return "#FFA500";
  }
};

export const getStatusText = (status: RecordStatusType) => {
  switch (status) {
    case RecordStatusType.PENDING:
      return "Pending";
    case RecordStatusType.APPROVED:
      return "Approved";
    case RecordStatusType.REJECTED:
      return "Rejected";
    case RecordStatusType.IN_PROGRESS:
      return "In Progress";
  }
};
